import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  instructionsDetails: [],
  current: null,
  modal: false,
  instructionEdit: false,
  loading: false,
  searchInstruction: "",
  edit: false,
};

const InstructionReducer = createSlice({
  name: "instructionReducer",
  initialState,
  reducers: {
    updateInstructionEdit: (state, { payload }) => {
      state.instructionEdit = payload;
    },
    updateLoadingInstruction: (state, { payload }) => {
      state.loading = payload;
    },
    updateEdit: (state, { payload }) => {
      state.edit = payload;
    },
    updateSearchInstruction: (state, { payload }) => {
      state.searchInstruction = payload ?? "";
    },
    updateModal: (state, { payload }) => {
      state.modal = payload;
      if (!payload) {
        state.current = null;
        state.instructionEdit = false;
      }
    },

    updateInstructions: (state, { payload }) => {
      state.instructionsDetails = Array.isArray(payload) ? payload : [];
    },

    setCurrentInstruction: (state, { payload }) => {
      state.current = payload;                
      state.instructionEdit = !!payload;       
    },
  },
});

export const {
  updateSearchInstruction,
  updateLoadingInstruction,
  updateInstructionEdit,
  updateModal,
  updateInstructions,
  updateEdit,
  setCurrentInstruction,
} = InstructionReducer.actions;

export default InstructionReducer.reducer;
